export default "__VITE_ASSET__D8WvO7j___"